import types from './types';

// ------------------------------------
// Reducer
// ------------------------------------

export function adPortfolios(state = [], action) {
  switch (action.type) {
    case types.RECEIVE_ADPORTFOLIOS:
      return action.adPortfolios;
    case types.CLEAR_ADPORTFOLIOS:
      return [];
    default:
      return state;
  }
}

// this use for maping the adPortfolios to with its current month's mtdSpend and projectedSpend
export function adPortfoliosData(state = null, action) {
  switch (action.type) {
    case types.RECEIVE_ADPORTFOLIOS_DATA: {
      return action?.adPortfoliosData;
    }
    case types.CLEAR_ADPORTFOLIOS_DATA:
      return null;
    default:
      return state;
  }
}
